import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ButtonGroup from "../ButtonGroup";
import dictionary from "../../../dictionary";
import { shortCurrency } from "../../../utils/currency";
import LegendsTooltip from "./LegendsTooltip";
import styles from "./button-group.module.scss";

function Quality(props) {
  const {name, content, onChange, current, vendorStyle, currency} = props;

  return (
    <div className={styles.root}>
      <ButtonGroup
        current={current}
        buttons={content}
        onChange={(value) => onChange(name, value)}
        vendorStyle={vendorStyle}
        renderButton={({value, difference}) =>
          value === `premium` ? (
            <LegendsTooltip
              title={
                <div>
                  <h4>3 отличия премиальных футболок:</h4>
                  <p style={{fontSize: `13px`}}>
                    1) высокая плотность материала 160гр <br />
                    2) повышенная гладкость за счёт дополнительной обрабоки от
                    ворса
                    <br />
                    3) малоусадочное полотно - футболка не садится после стирки
                    {` `}
                  </p>
                </div>
              }
            >
              <span className={styles.value}>
                {dictionary.item[value]}
                {` `}
                {value !== current && difference && (
                  <span className={styles.difference}>
                    {difference > 0 && `+`}
                    {difference}{shortCurrency(currency, difference)}
                  </span>
                )}
              </span>
            </LegendsTooltip>
          ) : (
            <span className={styles.value}>
              {dictionary.item[value]}
              {` `}
              {value !== current && difference && (
                <span className={styles.difference}>
                  {difference > 0 && `+`}
                  {difference}{shortCurrency(currency, difference)}
                </span>
              )}
            </span>
          )
        }
      />
      <span className={styles.label}>– выберите качество</span>
    </div>
  );
}

Quality.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
  vendorStyle: PropTypes.string
};

const mapStateToProps = (state) => ({
  currency: state.currency
})

export default connect(mapStateToProps)(Quality);
